import './travel.scss';
import 'slick-carousel';
export default () => {
	// Tabs
	$( '.travel__tab-handle li:first-child' ).addClass( 'active' );
	$( '.tab-content' ).hide();
	$( '.tab-content:first' ).show();

	// Click function
	$( '.travel__tab-handle li' ).click( function () {
		$( '.travel__tab-handle li' ).removeClass( 'active' );
		$( this ).addClass( 'active' );
		$( '.tab-content' ).hide();

		let activeTab = $( this ).find( 'a' ).attr( 'href' );

		$( activeTab ).fadeIn();

		return false;
	} );

	// Slick slider
	$( '.js-week-slider' ).slick( {
		rows: 0,
		dots: false,
		arrows: true,
		infinite: true,
		appendArrows: '.travel__arrows',
		prevArrow: '<button class="slick-prev"><i class="icon-arrow-left"></i></button>',
		nextArrow: '<button class="slick-next"><i class="icon-arrow-right"></i></button>',
		speed: 300,
		slidesToShow: 6,
		responsive: [
			{
				breakpoint: 1710,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 1280,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
		],
	} );
};
